/* eslint-disable no-else-return */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import avatar from 'assets/no-photo.png';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import Loading from 'components/atoms/Loading/Loading';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import ConfirmDelete from 'components/atoms/ConfirmDelete/ConfirmDelete';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const tableHeaders = [
  { id: 'id', label: 'id', width: '4%', align: 'center', type: 'id' },
  { id: 'name', label: 'Nazwa', width: '15.6%', align: 'center', type: 'string' },
  {
    id: 'category_ingredient',
    label: 'Kategoria',
    width: '15.6%',
    align: 'center',
    type: 'string',
  },
  { id: 'calories', label: 'Kalorie', width: '15.6%', align: 'center', type: 'string' },
  { id: 'has_gluten', label: 'Gluten', width: '15.6%', align: 'center', type: 'stringRed' },
  { id: 'has_lactose', label: 'Laktoza', width: '15.6%', align: 'center', type: 'stringRed' },
  {
    id: 'has_translations',
    label: 'Tłumaczenia',
    width: '4%',
    align: 'center',
    type: 'hasTranslations',
  },
  { id: 'actions,', label: 'Akcje', width: '15.6%', align: 'center', type: 'buttons' },
];

const IconsWrapper = styled.div`
  position: relative;
`;

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

const useStyles1 = makeStyles(theme => ({
  root: {
    display: 'flex',
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = event => {
    onChangePage(event, 1);
  };

  const handleBackButtonClick = event => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = event => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = event => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage)));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableComponent = ({
  onDeleteIngredients,
  ig,
  igConfig,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const classes = useStyles();
  const [igList, setIgList] = useState([]);
  const [deleteConfirmVisable, setDeleteConfirmVisable] = useState([]);
  const createDataFuncVals = tableHeaders.map(el => el.id);

  useEffect(() => {
    if (ig) {
      setIgList(ig);
      const openArray = {};
      ig.map(el => {
        const key = (el.name + el.id.toString())
          .split('')
          .filter(e => e.trim().length)
          .join('');
        openArray[key] = false;
      });

      setDeleteConfirmVisable(openArray);
    }
  }, [ig]);

  const createData = (...params) => {
    const obj = {};
    // eslint-disable-next-line no-return-assign
    createDataFuncVals.map((el, index) => (obj[el] = params[index]));
    return obj;
  };

  let data = [];

  if (igList) {
    data = igList.map(el => {
      return {
        id: el.id,
        name: el.name,
        category_ingredient: el.category_ingredient?.name,
        calories: el.calories,
        has_gluten: el.has_gluten,
        has_lactose: el.has_lactose,
        has_translations: el.name_en,
      };
    });
  }

  const rows = data.map(el => {
    const funcParams = [];
    Object.keys(el).map(key => {
      funcParams.push(el[key]);
      return funcParams;
    });
    return createData(...funcParams);
  });

  const openDeleteConfirm = key => {
    setDeleteConfirmVisable(deleteConfirmVisable => ({
      ...deleteConfirmVisable,
      [key]: !deleteConfirmVisable[key],
    }));
  };

  if (igConfig === null) {
    return <Loading />;
  } else {
    return (
      <>
        <Paper className={classes.root}>
          <TableContainer>
            <Table className={classes.table} stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {tableHeaders.map(head => {
                    if (head.type === 'id') {
                      return null;
                    } else {
                      return (
                        <React.Fragment key={head.value}>
                          <StyledTableCell align={head.align} style={{ width: head.width }}>
                            {head.label}
                          </StyledTableCell>
                        </React.Fragment>
                      );
                    }
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => {
                  return (
                    <React.Fragment key={row.code}>
                      <TableRow hover role="checkbox" tabIndex={-1}>
                        {tableHeaders.map(head => {
                          const value = row[head.id];
                          const newKey = (row.name + row.id.toString())
                            .split('')
                            .filter(e => e.trim().length)
                            .join('');
                          if (head.type === 'id') {
                            return null;
                          }

                          if (head.type === 'hasTranslations') {
                            if (value === null || value === '') {
                              return (
                                <React.Fragment key={head.id}>
                                  <TableCell align={head.align}>
                                    <CloseOutlinedIcon color="error" />
                                    <Typography variant="subtitle2" color="error">
                                      brak tłumaczenia
                                    </Typography>
                                  </TableCell>
                                </React.Fragment>
                              );
                            }
                            return (
                              <React.Fragment key={head.id}>
                                <TableCell align={head.align}>
                                  <CheckOutlinedIcon color="secondary" />
                                </TableCell>
                              </React.Fragment>
                            );
                          }

                          if (head.type === 'stringRed') {
                            return (
                              <React.Fragment key={head.id}>
                                <TableCell align={head.align}>
                                  {value === 1 ? (
                                    <Typography color="error">Tak</Typography>
                                  ) : (
                                      <Typography>Nie</Typography>
                                    )}
                                </TableCell>
                              </React.Fragment>
                            );
                          } else if (head.type === 'buttons') {
                            return (
                              <React.Fragment key={head.id}>
                                <TableCell align={head.align}>
                                  <IconsWrapper>
                                    <IconButton
                                      aria-label="delete"
                                      // onClick={() => onDeleteIngredients(row.id)}
                                      onClick={() => openDeleteConfirm(newKey)}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                    <Link to={`/ingredients/edit/${row.id}`}>
                                      <IconButton aria-label="edit">
                                        <EditIcon />
                                      </IconButton>
                                    </Link>
                                    {deleteConfirmVisable[newKey] && (
                                      <ConfirmDelete
                                        width="1200%"
                                        newKey={newKey}
                                        name={row.name}
                                        onDeleteHandler={onDeleteIngredients}
                                        id={row.id}
                                        rejectHandler={openDeleteConfirm}
                                        isOpen={deleteConfirmVisable}
                                      >
                                        {' '}
                                        Czy napewno chcesz skasować
                                      </ConfirmDelete>
                                    )}
                                  </IconsWrapper>
                                </TableCell>
                              </React.Fragment>
                            );
                          } else {
                            return (
                              <React.Fragment key={head.id}>
                                <TableCell align={head.align}>{value}</TableCell>
                              </React.Fragment>
                            );
                          }
                        })}
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
              <TableFooter>
                <TableRow>
                  {igConfig !== null ? (
                    <TablePagination
                      rowsPerPageOptions={[
                        2,
                        6,
                        10,
                        15,
                        25,
                        100,
                        { label: 'All', value: igConfig.total },
                      ]}
                      count={igConfig.total || 1}
                      rowsPerPage={igConfig.per_page}
                      page={igConfig.current_page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  ) : (
                      '.'
                    )}
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Paper>
      </>
    );
  }
};

export default TableComponent;
